import { alertActions } from './AlertsActions'
import { measurementLocalize } from '../../constants'
import { axiosPrivate } from '../../../axios'
import { meterType } from '../../../../../server/common/constants/Meters.constants'

export const DELETE_MEASUREMENT_INIT = 'DELETE_MEASUREMENT_INIT'
export const DELETE_MEASUREMENT_REQUEST = 'DELETE_MEASUREMENT_REQUEST'
export const DELETE_MEASUREMENT_SUCCESS = 'DELETE_MEASUREMENT_SUCCESS'
export const DELETE_MEASUREMENT_ERROR = 'DELETE_MEASUREMENT_ERROR'

export const deleteMeasurement =
	({ ids, sensorType }) =>
	(dispatch) => {
		dispatch({
			type: DELETE_MEASUREMENT_REQUEST,
			payload: {
				ids
			}
		})
		axiosPrivate
			.post(`/measurement/${sensorType === meterType.C5 ? 'c5/' : sensorType === meterType.PRVN ? 'prvn/' : ''}action/delete`, { ids })
			.then((res) => {
				dispatch({
					type: DELETE_MEASUREMENT_SUCCESS,
					payload: {
						data: res.data
					}
				})
				dispatch(alertActions.successEnqueueSnackbar(measurementLocalize.deleteSuccess(ids)))
			})
			.catch((error) => {
				dispatch({
					type: DELETE_MEASUREMENT_ERROR,
					payload: {
						error
					}
				})
				dispatch(alertActions.errorEnqueueSnackbar(error?.message || measurementLocalize.deleteError(ids)))
			})
	}

export const initDeleteMeasurement = () => (dispatch) => {
	dispatch({ type: DELETE_MEASUREMENT_INIT })
}
